import "./SafetySecurityAccessoriesAndSampling.module.css";
import Header from "@/reusable_sections/Header";
import SafetyHero from "./sections/SafetyHero";
import ProductCategories from "./sections/ProductCategories";
import SolutionsOverview from "./sections/SolutionsOverview";
import ServicesSupport from "./sections/ServicesSupport";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function SafetySecurityAccessoriesAndSamplingPage() {
  return <div>
      <Header />
      <SafetyHero />
      <ProductCategories />
      <SolutionsOverview />
      <ServicesSupport />
      <Inquiry />
      <Footer />
    </div>;
}